<!-- eslint-disable vue/multi-word-component-names -->
<!-- The Sweetheart Deal View -->
<template>
  <div class="break"></div>
  <page-layout left right header="The Sweetheart Deal" :hook="hook">
    <template #left>
      <book-menu />
    </template>
    <template #right>
      <book-content :book="bookCover" :paragraphs="introParagraphs" />
      <divider />
      <p class="other-paragraph">
        Gorgeously crafted and pitch-perfect in its details,
        <em>The Sweetheart Deal</em>
        is the heartrending story of how people move on in the wake of
        devastating loss—and of what happens when the chance for love
        unexpectedly appears again.
      </p>
      <divider />
      <h4>Purchase the Book</h4>
      <div class="buttonBox">
        <Button label="Amazon" :link="buttonLinks.amazon" />
        <Button label="Powell's Books" :link="buttonLinks.powells" />
        <Button label="Broadway Books" :link="buttonLinks.broadwayBooks" />
      </div>
      <divider />
      <book-praise header="Praise" :praises="bookPraise" />
    </template>
  </page-layout>
</template>

<script>
// import components
import PageLayout from "@/components/global-styles/layout/PageLayout.vue";
import BookMenu from "@/components/global-styles/default/BookMenu.vue";
import BookContent from "@/components/global-styles/layout/BookContent.vue";
import Divider from "@/components/global-styles/default/Divider.vue";
import Button from "@/components/global-styles/components/Button.vue";
import BookPraise from "@/components/global-styles/layout/BookPraise.vue";

// import images
import tsdCover from "@/assets/images/book-covers/TSDCover.jpg";

export default {
  name: "TSDView",
  components: {
    PageLayout,
    BookMenu,
    BookContent,
    Divider,
    Button,
    BookPraise,
  },
  data() {
    return {
      bookCover: tsdCover,
      introParagraphs: [
        `Firefighter Leo McGeary has always joked that, in the event of his death, he wants Garrett, his lifelong best friend and a consummate bachelor, to marry his wife, Audrey. One drunken New Year’s Eve, he goes as far as to make Garrett sign a piece of paper promising to do so. Twelve years later, Garrett receives a phone call from Audrey in the idle of the night: Leo has died in a freak skiing accident. Within hours, Garrett quits his tenure-track job at Boston College, ends his latest casual relationship, and purchases a one-way ticket to Oregon to be with Leo’s family.`,
        `As Audrey learns to navigate life as a widow and as a single parent to her and Leo’s three sons, her feelings for Garrett become more than platonic. Garrett finds himself falling for Audrey and her boys, too, as they form a new kind of family together in Portland. But when Audrey learns of the drunken pact Garrett and Leo made all those years ago, the promise that brought Garrett out west and into her world becomes the obstacle to his remaining in it.`,
      ],
      buttonLinks: {
        amazon:
          "https://www.amazon.com/Sweetheart-Deal-Polly-Dugan/dp/031632034X/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=&sr=",
        powells:
          "https://www.powells.com/book/the-sweetheart-deal-9780316320351",
        broadwayBooks: "https://www.broadwaybooks.net/book/9780316320344",
      },
      hook: `A young widow and her husband’s bachelor best friend fall in love, but
        even if it’s what the husband wanted, is it real?`,
      bookPraise: [
        {
          quote:
            "<em>The Sweetheart Deal</em> hits all of my favorite topics: loss, friendship, betrayal—but ultimately love. It’s the most romantic story I’ve read in years.",
          attribution:
            "—Elin Hilderbrand, author of <em>The Matchmaker</em> and <em>The Rumor</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "There is tender romance here, but it’s more richly a story of an old family falling away and a new one beginning.",
          attribution: "—<em>Kirkus Reviews</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "A charming, poignant novel of dealing with grief and finding love again, this is the perfect lighthearted page-turner for the shore.",
          attribution: "—Marisa Spyker, <em>Coastal Living</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "Heartfelt and wise, Polly Dugan’s <em>The Sweetheart Deal</em> reminds us that every difficult ending can lead to a beautiful new beginning.",
          attribution:
            "—Sarah Jio, author of <em>The Violets of March</em> and <em>Goodnight Jane</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "<em>The Sweetheart Deal</em>, a beautifully written debut, proves best love stories are the unconventional ones. Fans of Good Grief and PS, I Love You will adore this novel, which is brimming with heart and hope and perfectly balanced by the bittersweet.",
          attribution: "—Sarah Pekkanen, author of <em>The Opposite of Me</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "A poignant exploration of a family not just recovering from loss, but growing stronger in its wake. Polly Dugan’s debut novel moved me to tears and challenged my assumptions as it explored what any of us would do when offered a second chance at love.",
          attribution:
            "—Miranda Beverly-Whittemore, author of <em>Bittersweet</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote:
            "<em>The Sweetheart Deal</em> intimately explores how grief can affect family.",
          attribution: "—Joy Gunn, <em>Library Journal</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
        {
          quote: "A sensitive portrayal of friendship, family, and loss.",
          attribution: "—Mary Ellen Quinn, <em>Booklist</em>",
          quotePrefix: true,
          quoteSuffix: true,
        },
      ],
    };
  },
};
</script>
